import { useApi } from '@/shared/api/http';
import type {
  IGetFeedbacksParams,
  ISendFeedbackReviewData,
  ISendFeedbackData,
  ISendFeedbackResponse,
} from '@/entities/feedback/model/types/feedback';

export const useFeedbackService = () => {
  const api = useApi();

  const getAllFeedbacks = async (params: IGetFeedbacksParams) => {
    return await api.get('feedback/', { params: { ...params } });
  };

  const sendFeedbackComment = async (
    feedbackId: number,
    data: ISendFeedbackReviewData,
  ) => {
    return await api.post(`feedback/${feedbackId}/review`, data);
  };

  const sendFeedback = async (data: ISendFeedbackData) => {
    return await api.post<ISendFeedbackResponse>('feedback', data);
  };

  return {
    getAllFeedbacks,
    sendFeedbackComment,
    sendFeedback,
  };
};
